/**
 * Consumer Pro checkout billing cadence — must match server
 * `CONSUMER_PRO_CHECKOUT_INTERVAL_*` in `server/src/constants/stripeConsumer.constants.js`.
 */
export const CONSUMER_PRO_BILLING_INTERVAL = {
  MONTH: 'month',
  YEAR: 'year',
} as const

export type ConsumerProBillingInterval =
  (typeof CONSUMER_PRO_BILLING_INTERVAL)[keyof typeof CONSUMER_PRO_BILLING_INTERVAL]
